/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import SShop from 'shared/screens/Shop';
import { ShopTabs } from 'shared/screens/Shop/Constants';
import ImageBW from '../../components/ImageBoundsWrapper';
import CoinItem from './CoinItem';
import StoreVipItems from './StoreVipItems';
import Modal from '../../components/JSModal';
import GenericMessage from '../../screens/GenericMessage/GenericMessage';
import TimeRemainingText from '../../components/TimeRemainingText';
import Animated from 'animated/lib/targets/react-dom';
import { ThemeContext } from 'styled-components';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import Button from '../../components/Button/Button';
import ModalHeader from './components/ModalHeader';
import {
  ModalWrapper,
  headerTitleWrapperStyle,
  ErrorMessageWrapper,
  headerContainerStyle,
  ErrorMessageText,
  titleStyle,
  VipPackagesContainer,
} from './components/styledComponents';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import LazyImage from '../../components/LazyImage/LazyImage';
import { TAG } from 'shared/constants';
import CustomScrollBar from '../../components/CustomScrollBar';
import './storeScrollBarStyles.scss';
import { isNotStandaloneMobilePWA, isStandalonePWA } from '../../utils/mobileSupported';
import { PromoActionKey } from 'shared/utils/PromotionAction';

export default class Shop extends Component {
  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-shop',
      dismissPromoAction: PromoActionKey.GO_TO_COIN_STORE,
    };
  }

  /** @typedef {import('shared/api/Constants').CurrencyPackageItemKeys} CPIK */
  /** @typedef {import('shared/api/Constants').CurrencyPackageNewsListItemKeys} News */

  render() {
    const themeContext = this.context;
    const windowWidth = window.innerWidth;
    return (
      <SShop
        navigation={this.props.navigation}
        dismissModal={this.props.dismissModal}
        render={
          /**
           * @param {Object} args
           * @param {News[]} args.newsItems
           * @param {BP[]} args.vipItems
           * @param {String} args.shopTab Current shop tab
           * @param {Function} args.setShopTabHandler Takes a ShopTab constant
           * @param {Function} args.buyHandle purchase handler
           * @param {Object} args.coinSale coin sale info
           * @param {String} args.coinSale.backgroundImage if not null, background image
           * @param {String} args.coinSale.headerImage if not null, header image
           */
          args => {
            const {
              coinItems,
              vipItems,
              shopTab,
              setShopTabHandler,
              buyHandle,
              coinSale,
              isSaleOn,
              hasExclusiveSalePackages,
              unlimitedVipAccess,
              showPromoBoost,
              promoBoostDialogType,
              promoBoostDialogMessage,
              promoBoostDialogButtonHandle,
              assetsUrls,
              hasVIPPass,
            } = args;

            const modalInsets = {
              top:
                promoBoostDialogType === 'success'
                  ? !isTablet && isMobile
                    ? 70
                    : 150
                  : !isTablet && isMobile
                    ? '17vmin'
                    : '23vmin',
              left: promoBoostDialogType === 'success' ? 365 : isTablet ? '26%' : '22%',
              right: promoBoostDialogType === 'success' ? 365 : isTablet ? '26%' : '22%',
              bottom:
                promoBoostDialogType === 'success'
                  ? !isTablet && isMobile
                    ? 70
                    : 150
                  : !isTablet && isMobile
                    ? '17vmin'
                    : '23vmin',
            };

            if (!shopTab) {
              return <div></div>;
            }

            let currentTab = {
              image: assetSource(ASSET_KEY.COINS_TAB_ACTIVE),
              ibw: require(asset`images/coin-store-assets/coins-tab-active.ibw`),
            };
            if (shopTab === ShopTabs.VIP) {
              currentTab.image = assetSource(ASSET_KEY.VIP_TAB_ACTIVE);
              currentTab.ibw = require(asset`images/coin-store-assets/vip-tab-active.ibw`);
            }

            return (
              <>
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                >
                  <LazyImage
                    tag={TAG.IMG}
                    className={`${isStandalonePWA && !isTablet ? 'ShopBackgroundPwa' : 'ShopBackground'}`}
                    src={
                      coinSale.backgroundImage
                        ? assetsUrls.promotionImagesUrl + '/' + coinSale.backgroundImage
                        : assetSource(ASSET_KEY.DEFAULT_BACKGROUND)
                    }
                    onError={ev => (ev.target.src = assetSource(ASSET_KEY.DEFAULT_BACKGROUND))}
                  />
                </div>
                <ImageBW
                  className="PopupOverlay"
                  source={assetSource(ASSET_KEY.POPUP_FRAMING)}
                  ibw={require(asset`popup-framing.ibw`)}
                  manualAssetScale={3}
                  style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    zIndex: 11,
                  }}
                />
                <div style={themeContext.ShopScreen}>
                  <div style={themeContext.ShopScreen.ShopContainer}>
                    <div style={themeContext.ShopScreen.ShopContainer.ShopHeader}></div>
                    <div style={themeContext.ShopScreen.ShopContainer.PackagesContainer}>
                      <div style={themeContext.ShopScreen.ShopContainer.PackagesContainer.TabButtonsContainer}>
                        <button
                          style={themeContext.ShopScreen.ShopContainer.PackagesContainer.TabButtonsContainer.TabButton}
                          onClick={() => setShopTabHandler(ShopTabs.COINS)}
                        />
                        <button
                          style={themeContext.ShopScreen.ShopContainer.PackagesContainer.TabButtonsContainer.TabButton}
                          onClick={() => setShopTabHandler(ShopTabs.VIP)}
                        />
                      </div>
                      <ImageBW
                        ibw={currentTab.ibw}
                        source={currentTab.image}
                        style={{
                          flex: 1,
                          zIndex: 10,
                        }}
                        innerStyle={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          overflowY: 'auto',
                          overflowX: 'hidden',
                          paddingTop: !isMobile && windowWidth < 1300 ? '10%' : '8%',
                          height: '100%',
                        }}
                      >
                        <div style={themeContext.ShopScreen.ShopContainer.PackagesContainer.CoinItemContainer}>
                          {shopTab === ShopTabs.COINS && (
                            <CoinStoreCoinsWrapper>
                              {coinItems.map(item => (
                                <CoinItem
                                  key={item.ORDER + ''}
                                  item={item}
                                  buyHandle={buyHandle}
                                  showPromoBoost={showPromoBoost}
                                  hasExclusiveSalePackages={hasExclusiveSalePackages}
                                  assetsUrls={assetsUrls}
                                />
                              ))}
                            </CoinStoreCoinsWrapper>
                          )}
                          {shopTab === ShopTabs.VIP && (
                            <VipPackagesContainer>
                              {vipItems.map((item, index) => (
                                <StoreVipItems
                                  key={item.ORDER ?? index}
                                  item={item}
                                  index={index}
                                  buyHandle={buyHandle}
                                  hasVIPPass={hasVIPPass}
                                  unlimitedVipAccess={unlimitedVipAccess}
                                />
                              ))}
                            </VipPackagesContainer>
                          )}
                        </div>
                      </ImageBW>
                    </div>
                  </div>
                  {isSaleOn && (
                    <ImageBW
                      source={assetSource(ASSET_KEY.COIN_GLOWING_CONTAINER)}
                      ibw={require(asset`images/coin-store-assets/glowing-container.ibw`)}
                      className="saleTimer"
                      style={themeContext.ShopScreen.SaleTimer}
                      widthScale={0.285}
                    >
                      <LazyImage
                        tag={TAG.IMG}
                        src={assetSource(ASSET_KEY.CLOCK_ICON_GLOWING)}
                        alt={'Clock Icon'}
                        className="timerIcon"
                      />
                      {coinSale.endDate > 0 && (
                        <>
                          <TimeRemainingText
                            className="timerLabel"
                            until={coinSale.endDate} // Assuming server sends the time remaining in seconds
                          />
                        </>
                      )}
                    </ImageBW>
                  )}
                  {promoBoostDialogType !== null && !!promoBoostDialogMessage && (
                    <Modal
                      isVisible={true}
                      onBackButtonPress={promoBoostDialogButtonHandle}
                      zIndex={9999}
                      hideCloseButton={true}
                      insets={modalInsets}
                      hideOverlay={true}
                      dialogClassName={'promo-link-applied'}
                      modalMainBodyStyle={{
                        minHeight: promoBoostDialogType === 'success' && !isMobile ? '32em' : '20vmin',
                      }}
                    >
                      {promoBoostDialogType === 'success' ? (
                        <GenericMessage
                          message={promoBoostDialogMessage}
                          dismissModal={promoBoostDialogButtonHandle}
                          title={`${getText(TEXT_KEY.CONGRATULATIONS)}!`}
                          navigation={this.props.navigation}
                          dividerImage
                          centerImage={{
                            src: assetSource(ASSET_KEY.COIN_GRAPHIC_SALE),
                          }}
                          buyNowButton
                        />
                      ) : (
                        <>
                          <div className="ModalBackground hideBefore">
                            <ImageBW
                              className="ModalBackgroundAsset"
                              as={Animated.div}
                              source={assetSource(ASSET_KEY.MODAL_BACKING_9_SLICE_WEB)}
                              ibw={require(asset`modal-backing-9-slice.ibw`)}
                              widthScale={0.5}
                            />
                          </div>
                          <div className="ModalCloseButton" onClick={promoBoostDialogButtonHandle}>
                            <ImageBW
                              source={assetSource(ASSET_KEY.CLOSE_BUTTON)}
                              ibw={require(asset`close-button.ibw`)}
                              manualAssetScale={3}
                              style={{ objectFit: 'contain', height: '100%', width: '100%' }}
                              innerStyle={{ cursor: 'pointer' }}
                              alt="Close"
                            />
                          </div>
                          <ModalWrapper>
                            <ModalHeader
                              titleStyle={titleStyle}
                              headerTitleWrapperStyle={headerTitleWrapperStyle}
                              containerStyle={headerContainerStyle}
                              title={getText(TEXT_KEY.SORRY)}
                            />
                            <ErrorMessageWrapper>
                              <LazyImage
                                tag={TAG.IMG}
                                style={{ width: '9%', zIndex: 1, margin: '1rem 0' }}
                                src={assetSource(ASSET_KEY.WARNING_SYMBOL)}
                              />
                              <ErrorMessageText>{getText(TEXT_KEY.ALREADY_CLAIMED_BONUS_OR_EXPIRED)}</ErrorMessageText>
                              <Button
                                imageSource={assetSource(ASSET_KEY.ROUNDED_RECT_PRIMARY)}
                                imageStyle={{ width: '25%' }}
                                containerStyle={{ height: '100%' }}
                                onClick={promoBoostDialogButtonHandle}
                                label={getText(TEXT_KEY.OK)}
                              />
                            </ErrorMessageWrapper>
                          </ModalWrapper>
                        </>
                      )}
                    </Modal>
                  )}
                </div>
              </>
            );
          }
        }
      />
    );
  }
}

Shop.contextType = ThemeContext;

const CoinStoreCoinsWrapper = ({ children }) => {
  if (isNotStandaloneMobilePWA) {
    return (
      <CustomScrollBar timeout={700} customClassNames={`custom-scrollbar-store`}>
        {children}
      </CustomScrollBar>
    );
  }

  return children;
};

